export default "__VITE_ASSET__1d_LZ0C0__"